import { render } from "./TheBreadcrumbs.vue?vue&type=template&id=bf345b94"
import script from "./TheBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./TheBreadcrumbs.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./TheBreadcrumbs.vue?vue&type=style&index=0&id=bf345b94&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script